import React, { useState } from "react";

import { Tooltip } from "@synthesis/shared-ui";
import { cn } from "@synthesis/shared-utils";

type ListItemProps = {
  title: string;
  index?: number;
  handleItemClick?: (item: string, fileMetaId: string) => void;
  isActive?: boolean;
  rightBar?: boolean;
  handleHeadingClick?: (item: string) => void;
  fileMetaId?: string;
};

export const ListItem = ({ title, index, handleItemClick, isActive, rightBar, handleHeadingClick, fileMetaId }: ListItemProps) => {
  const ref = React.useRef<HTMLDivElement | HTMLLIElement | null>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  React.useEffect(() => {
    if (ref.current) {
      const isTextTruncated = ref.current.scrollWidth > ref.current.clientWidth;
      setIsTruncated(isTextTruncated);
    }
  }, [title]);

  const content = rightBar ? (
    <div
      ref={ref as React.RefObject<HTMLDivElement>}
      onClick={() => fileMetaId && handleItemClick?.(title, fileMetaId)}
      className={cn(
        "subtitle-base text-type-minor hover:bg-neutrals-99 w-[260px] cursor-pointer truncate rounded-t-lg px-3 py-2",
        isActive && "bg-brand-99 text-brand-40 hover:bg-brand-95 rounded-t-lg",
      )}
    >
      {(index ?? 0) + 1}. {title}
    </div>
  ) : (
    <li
      onClick={() => handleHeadingClick?.(title)}
      ref={ref as React.RefObject<HTMLLIElement>}
      className={cn("subtitle-sm w-[240px] cursor-pointer truncate px-3 py-1.5", isActive ? "text-neutrals-20" : "text-type-minor")}
    >
      {title}
    </li>
  );

  return isTruncated ? <Tooltip description={title}>{content}</Tooltip> : content;
};
